import { Box, Button, Typography } from '@material-ui/core';
import { generatePDF } from '../common';
import { DocumentTempPrint } from '../Sections/generator/print/DocumentTempPrint';
import MyIcon from './MyIcon';

export default function PrintDownload({
  company,
  printData,
  template,
  templates,
  componentRef,
  handleReactPrint,
  componentRef2,
  handleReactPrint2,
  isRTL,
  no,
  element,
  isNew,
}: any) {
  if (templates && templates?.length > 0) {
    return (
      <div>
        {templates?.map((temp: any, index: any) => {
          return (
            <Box
              style={{
                margin: 10,
                padding: 10,
                borderRadius: 10,
                backgroundColor: '#fff',
                // display: 'flex',
              }}
            >
              <Box
                style={{
                  display: isNew ? 'none' : 'flex',
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  marginLeft: 20,
                  marginRight: 20,
                }}
              >
                <Typography>{temp.name}</Typography>
                <Button
                  variant="text"
                  endIcon={<MyIcon icon="print" size={20} />}
                  onClick={index === 0 ? handleReactPrint : handleReactPrint2}
                  style={{ marginLeft: 10, marginRight: 10 }}
                >
                  Print
                </Button>
                <Button
                  onClick={() =>
                    generatePDF({ no, template: temp, element: temp.name })
                  }
                  variant="text"
                  endIcon={<MyIcon icon="pdf" size={20} />}
                  style={{ marginLeft: 10, marginRight: 10 }}
                >
                  Download
                </Button>
              </Box>
              <div
                id={temp.name}
                style={{
                  position: 'fixed',
                  left: '-999em',
                  direction: 'ltr',
                  width:
                    template?.size === 'POS'
                      ? '80mm'
                      : template?.size === 'A5'
                      ? '148mm'
                      : '210mm',
                }}
              >
                <DocumentTempPrint
                  company={company}
                  data={printData}
                  template={temp}
                  ref={index === 0 ? componentRef : componentRef2}
                  isRTL={isRTL}
                ></DocumentTempPrint>
              </div>
            </Box>
          );
        })}
      </div>
    );
  } else {
    return (
      <Box
        style={{
          margin: 10,
          padding: 10,
          borderRadius: 10,
          display: 'flex',
        }}
      >
        <Box
          style={{
            display: isNew ? 'none' : 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          <Button
            variant="text"
            endIcon={<MyIcon icon="print" size={20} />}
            onClick={handleReactPrint}
            style={{ marginLeft: 10, marginRight: 10 }}
          >
            Print
          </Button>
          <Button
            onClick={() => generatePDF({ no, template, element })}
            variant="text"
            endIcon={<MyIcon icon="pdf" size={20} />}
            style={{ marginLeft: 10, marginRight: 10 }}
          >
            Download
          </Button>
        </Box>
        <div
          id={element}
          style={{
            position: 'fixed',
            left: '-999em',
            direction: 'ltr',
            width:
              template?.size === 'POS'
                ? '80mm'
                : template?.size === 'A5'
                ? '148mm'
                : '210mm',
          }}
        >
          <DocumentTempPrint
            company={company}
            data={printData}
            template={template}
            ref={componentRef}
            isRTL={isRTL}
          ></DocumentTempPrint>
        </div>
      </Box>
    );
  }
}
